import staticPageTitles from './routes-titles';
import { I18n } from 'react-redux-i18n';
import pathToRegexp from 'path-to-regexp/index';

function parseArrayFromString(param) {
  const regexp = /[^,[\]/]+/gm;
  if (param) {
    let transf = `[${param}]`.replace(regexp, (match) => {
      return '"' + match + '"';
    });
    return JSON.parse(transf);
  }

  return [];
}

function parseRouteParams(routeParams) {
  const eventId = routeParams.eventId ? JSON.parse(routeParams.eventId) : null;
  const routeDetails = {
    sports: parseArrayFromString(routeParams.sports),
    regions: parseArrayFromString(routeParams.regions),
    leagues: parseArrayFromString(routeParams.leagues),
    participants: parseArrayFromString(routeParams.participants),
    attributes: parseArrayFromString(routeParams.attributes),
    eventId: eventId
  };

  return routeDetails;
}

function isSportSpecificPage(params) {
  const { sports, regions, leagues } = parseRouteParams(params);

  const S1 = sports.length === 1 ? sports[0] : null;
  const S2 = regions.length === 1 ? regions[0] : null;
  const S3 = leagues.length === 1 ? leagues[0] : null;


  const s1valid = (S1 !== null) && (S1 !== 'all');
  const s2empty_s3empty = (S2 == null && S3 == null);
  const s2all_s3all = (S2 === 'all' && (S3 === 'all' || S3 == null));
  const s2valid_s3anything = ((S2 !== null && S2 !== 'all') && true);


  let isSportsSpecificPage =
    s1valid
    && (
      s2empty_s3empty
      || s2all_s3all
      || s2valid_s3anything
    );

  return isSportsSpecificPage;

}

function getSpecificNameIfExists(pathname) {
  let pageName = null;
  for (let path in staticPageTitles) {
    let re = pathToRegexp(path);
    let matchFound = re.exec(pathname);
    if (matchFound) {
      pageName = I18n.t(staticPageTitles[path]);
      break;
    }
  }

  return pageName;
}

function getUniqueKeyOfSportFromRoute(routeParams) {
  const routeDetails = parseRouteParams(routeParams);
  const { sports, regions, leagues } = routeDetails;
  const uniqueTermKey = [sports[0], regions[0], leagues[0]].filter(val => val && val !== 'all').join('-');

  return uniqueTermKey;
}

function getGroupDetails(routeParams, uniqueKeyToGroupDetails, sportGroups) {

  const uniqueTermKey = getUniqueKeyOfSportFromRoute(routeParams);
  if (!uniqueKeyToGroupDetails[uniqueTermKey]) return null;

  const sportgroupId = uniqueKeyToGroupDetails[uniqueTermKey];

  return sportGroups[sportgroupId];
}

export default {
  getGroupDetails: getGroupDetails,
  getSpecificNameIfExists: getSpecificNameIfExists,
  isSportSpecificPage: isSportSpecificPage
};
